export default [
  { title: 'None', value: '' },
  { title: 'John', value: 'John' },
  { title: 'Megan', value: 'Megan' },
  { title: 'Tomas', value: 'Tomas' },
  { title: 'Sean Bedford', value: 'Sean Bedford' },
  { title: 'Sean Byrne', value: 'Sean Byrne' },
  { title: 'Katherine', value: 'Katherine' },
  { title: 'Ciara', value: 'Ciara' },
  { title: 'MaryClaire', value: 'MaryClaire' },
  { title: 'Grace', value: 'Grace' },
  { title: 'Fiona', value: 'Fiona' },
  { title: 'Richard', value: 'Richard' },
  { title: 'Breege', value: 'Breege' },
  { title: 'Becky', value: 'Becky' },
  { title: 'Monica', value: 'Monica' },
  { title: 'Daniel', value: 'Daniel' }
];
